// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_wFc","right":"styles_right__3Tz6z"};